/**
 * Compatibility shim — all calls now route through the central
 * tactile feedback engine which combines real vibration (where
 * supported) with premium micro-sound fallback (iPhone/iPad) and
 * optional native Capacitor haptics.
 *
 * See `src/lib/tactileFeedback.ts` for the full engine.
 *
 * Disable at runtime:
 *   localStorage.setItem("frankPistoriusHaptics", "off")  // vibration only
 *   localStorage.setItem("frankPistoriusSound", "off")    // sound only
 *   localStorage.setItem("frankPistoriusFeedback", "off") // master off
 */

import { feedback } from "@/lib/tactileFeedback";

export function canUseHaptics(): boolean {
  return feedback.isFeedbackEnabled();
}

export const haptics = {
  light:     () => feedback.light(),
  selection: () => feedback.selection(),
  medium:    () => feedback.medium(),
  success:   () => feedback.success(),
  warning:   () => feedback.warning(),
  error:     () => feedback.error(),
  cancel:    () => feedback.cancel(),
  setEnabled(enabled: boolean) {
    feedback.setHapticsEnabled(enabled);
    feedback.setSoundEnabled(enabled);
  },
  isEnabled(): boolean {
    return feedback.isFeedbackEnabled();
  },
};

export default haptics;
